module.exports = __webpack_public_path__ + "media/character-grandpa-happy.40a31c49.mp3";